import React from 'react';

import CancelIcon from '/asset/close.svg';

interface PopupProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  popUpClass?: string;
  closeClass?: string;
}

const Popup: React.FC<PopupProps> = ({
  isOpen,
  onClose,
  children,
  popUpClass = '',
  closeClass = '',
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 flex items-center 
    justify-center bg-black bg-opacity-50 z-[1000]"
    >
      <div
        className={`bg-white p-6 shadow-lg relative rounded-md ${popUpClass}`}
      >
        <button
          className={`bg-black absolute top-[15px] w-[12px] right-[15px] 
              w-[15px] text-gray-500 hover:text-gray-700
              flex content-center items-center
              p-0 ${closeClass}`}
          aria-label="close button"
          onClick={onClose}
          type="button"
        >
          <img src={CancelIcon} className="w-[15px] h-[15px]" alt="cancel" />
        </button>

        {children}
      </div>
    </div>
  );
};

export default Popup;
